<template>
  <div>
    <AppNavbar v-if="isApp" :options="options" :zIndex="999" title="每日小目标">
      <div
        slot="right"
        class="save"
        @click.stop="bindSave"
        v-buried
        data-buried="BG_QRCAIPU_MUBIAO_BAOCUN"
        v-clickBuried
        data-click-buried="CLICK_QRCAIPU_MUBIAO_BAOCUN"
      >
        <span class="iconfont icon-download"></span><span>保存图片</span>
      </div>
    </AppNavbar>
    <DailyGoal />
    <!-- 海报 -->
    <CnaPoster ref="poster" :posterType="4" />
  </div>
</template>
<script>
import AppNavbar from '@/components/app/nav-bar/index.vue'
import DailyGoal from './components/result/daily-goal.vue'
import CnaPoster from './components/result/poster.vue'
export default {
  components: {
    AppNavbar,
    DailyGoal,
    CnaPoster
  },
  data() {
    return {
      isApp: false,
      options: {
        barBackgroundColor: 'transparent',
        color: 'rgba(255,255,255,1)'
      }
    }
  },
  created() {
    this.isApp = this.$betterwe.isApp()
  },
  mounted() {
    this.addScroll()
  },
  beforeDestroy() {
    this.removeScroll()
  },
  methods: {
    bindScroll(e) {
      let maxHeight = 100
      var scroll = document.documentElement.scrollTop || document.body.scrollTop
      if (scroll < maxHeight) {
        scroll = scroll < 0 ? 0 : scroll
        let per = (scroll / maxHeight).toFixed(2)
        let f = 1 - per
        this.options.color = 'rgba(255,255,255,' + (f >= 0 ? f : 0) + ')'
        this.options.barBackgroundColor = 'rgba(255,255,255,' + per + ')'
      } else {
        this.options.color = 'rgba(0,0,0,0.8)'
        this.options.barBackgroundColor = 'rgba(255,255,255,1)'
      }
    },
    addScroll() {
      window.addEventListener('scroll', this.bindScroll)
    },
    removeScroll() {
      window.removeEventListener('scroll', this.bindScroll)
    },
    bindSave() {
      this.$refs.poster.start()
    }
  }
}
</script>
<style lang="scss" scoped>
.save {
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 17px;
}
</style>
